import { render, staticRenderFns } from "./App.vue?vue&type=template&id=73e13695&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=73e13695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e13695",
  null
  
)

export default component.exports